window.text = {
    /**
     * Init Table scrollability
     */
    initTableScrollable: function() {
        this.checkScrollabilityOfTables();

        window.onresize = function() {
            window.text.checkScrollabilityOfTables();
        };
    },

    /**
     * Check the scrollability of the tables to show/remove the scroll table message
     */
    checkScrollabilityOfTables: function () {
        document.querySelectorAll('figure.table').forEach(function (item) {
            const tableScrollMessage = item.querySelector('.table-scroll-message');
            const table = item.querySelector('table');

            if (table.scrollWidth > table.offsetWidth) {
                tableScrollMessage.classList.remove('hide');
            }
            else {
                tableScrollMessage.classList.add('hide');
            }
        });
    },
}
